import { render, staticRenderFns } from "./FilterSelect.vue?vue&type=template&id=b2253bf4"
import script from "./FilterSelect.vue?vue&type=script&lang=js"
export * from "./FilterSelect.vue?vue&type=script&lang=js"
import style0 from "./FilterSelect.vue?vue&type=style&index=0&id=b2253bf4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports